import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { LocalesContextProvider } from 'utils/contexts/locales/localeSettings';
import { PaginationContextProvider } from 'utils/contexts/pagination';
import { SortingContextProvider } from 'utils/contexts/sorting';
import { ExpandModes, useExpansionContext } from 'utils/contexts/expansion';
import { Drawer } from 'ui/drawer';

import { CustomBehavioralContextProvider, InsightsQueryContextProvider } from './contexts';
import { Grid } from './Grid';
import { ListReferenceInsightsSection } from './ListReferenceInsightsSection';
import { DemographicInsightsSection } from './DemographicInsightsSection';
import { BehavioralInsightsSection } from './BehavioralInsightsSection';
import { ListUsageQueryContextProvider } from './contexts/ListUsageQueryContextProvider';
import { ListReferenceSortableProperty } from '../domain';
import { ConversionInsightsContextProvider } from './contexts/ConversionInsightsContext';
import { AudienceInsightsErrorBoundary } from './errorBoundary';
import { Title } from './Title';
import { Toolbar } from './Toolbar';
import { BehaviorQueryContextProvider } from './contexts/BehaviorQueryContextProvider';
import { ProfileQueryContextProvider } from './contexts/ProfileQueryContextProvider';

export const AudienceInsightsDrawer = () => {
  const { mode, collapse } = useExpansionContext();

  const drawerContent = (
    <Grid>
      <InsightsQueryContextProvider>
        <PaginationContextProvider>
          <AudienceInsightsErrorBoundary isSection>
            <BehaviorQueryContextProvider>
              <CustomBehavioralContextProvider>
                <ConversionInsightsContextProvider>
                  <BehavioralInsightsSection />
                </ConversionInsightsContextProvider>
              </CustomBehavioralContextProvider>
            </BehaviorQueryContextProvider>
          </AudienceInsightsErrorBoundary>
        </PaginationContextProvider>
        <AudienceInsightsErrorBoundary isSection>
          <ProfileQueryContextProvider>
            <DemographicInsightsSection />
          </ProfileQueryContextProvider>
        </AudienceInsightsErrorBoundary>
        <AudienceInsightsErrorBoundary isSection>
          <PaginationContextProvider>
            <SortingContextProvider
              defaultSortField={ListReferenceSortableProperty.name}
              defaultSortDirection={SORT_DIRECTIONS.DESCENDING}
            >
              <ListUsageQueryContextProvider>
                <ListReferenceInsightsSection />
              </ListUsageQueryContextProvider>
            </SortingContextProvider>
          </PaginationContextProvider>
        </AudienceInsightsErrorBoundary>
      </InsightsQueryContextProvider>
    </Grid>
  );

  return (
    <LocalesContextProvider>
      <Drawer
        title={<Title />}
        toolbar={<Toolbar />}
        isExpanded={mode === ExpandModes.expand}
        onClose={collapse}
      >
        <AudienceInsightsErrorBoundary>
          {mode === ExpandModes.expand ? drawerContent : null}
        </AudienceInsightsErrorBoundary>
      </Drawer>
    </LocalesContextProvider>
  );
};
